import { mapState } from 'vuex'
import { util } from './utils'
import {mapUsable} from './constants.js'
function mixins(config) {
  return {
    computed: {
      ...mapState({
        appId (state) {
          const app = state.bizSys.currentApp
          return (app || {}).id
        },
        platform () {
          return 0
        }
      }),
      isSaaS() {
        return config.isSaaS
      }
    },
    methods: {
      isMap(dimensionValue, targetValue) {
        let mapDimensionArr = mapUsable.dimension
        let mapTargetArr = mapUsable.target
        return (
          mapDimensionArr.includes(dimensionValue) &&
          mapTargetArr.includes(targetValue)
        )
      },
      replaceRouter(param) {
        let isSameRoute = true
        function compare(a, b) {
          for (let prop in a) {
            if (util.isObject(a[prop])) {
              compare(a[prop], b[prop])
            } else {
              if (a[prop] != b[prop]) isSameRoute = false
            }
          }
        }
        compare(param, this.$route)
        if (isSameRoute) {
          return
        }
        this.$router.replace(param)
      }
    }
  }
}
export default mixins